import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-116">
      {isVisible && <motion.div className="fixed bottom-0 left-0 w-full p-4 z-50 lg:hidden" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} data-id="element-117">
          {/* Blur backdrop */}
          <div className="absolute inset-0 bg-beige-light/80 backdrop-blur-md border-t border-beige-dark/30 -z-10" data-id="element-118"></div>

          <button onClick={scrollToCheckout} className="w-full py-4 bg-navy text-beige-light rounded-xl font-medium text-lg shadow-lg border border-gold/30 flex items-center justify-center gap-2 active:scale-[0.98] transition-transform" data-id="element-119">
            QUIERO MI ACCESO AHORA
          </button>
        </motion.div>}
    </AnimatePresence>;
}